import { Event, VideoWatchEvent } from '../types'

export function checkViewKeyInBufferWithProduct(eventBuffer: Array<Event | VideoWatchEvent>, product: string): boolean {
  return eventBuffer.some((event) => event.viewKey.includes(product))
}
